import { defineStore } from 'pinia'

type Nullable<T> = T | null;

interface State {
    user: Nullable<server.User>
}

export const useUserStore = defineStore('user', {
    state: (): State => {
        return {
            user: null
        }
    },
    getters: {

    },
    actions: {

    },
    persist: true,
});
